const useLocalStorage = (): [(key: string) => string, (key: string, value: string) => void, (key: string) => void] => {
    const getItem = (key: string) => localStorage.getItem(key) as string;
    const setItem = (key: string, value: string) => localStorage.setItem(key, value);
    const removeItem = (key: string) => localStorage.removeItem(key);

    return [getItem, setItem, removeItem];
};
export default useLocalStorage;